import React, { useState, useRef } from "react";
import "./style.scss";
import classNames from "classnames";
import SimpleHero from "../../sections/simple-hero";
import PdfLeadsForm from "../../sections/pdp-leads-form";
import config from "../../temp/config";
import api from "../../utils/api";
import TradeInSubmitted from "../../sections/trade-in-submitted";
import { scrollToSmooth } from "../../hooks/scrollToSmooth.js";
import { getOverallSettingsClasses } from "../../utils/siteUtils";

const PdpTradeIn = ({ fields, rendering, lang, page }) => {
  const {
    titleType,
    titleBody,
    headerType,
    headerBody,
    description,
    firstNameLabel,
    firstNameInfoText,
    firstNameMissingMessage,
    lastNameLabel,
    lastNameInfoText,
    lastNameMissingMessage,
    emailLabel,
    emailInfoText,
    emailWarningMessage,
    emailMissingMessage,
    phoneAreaLabel,
    phoneAreaInfoText,
    phoneLabel,
    phoneInfoText,
    phoneWarningMessage,
    phoneMissingMessage,
    countryLabel,
    countryWarningMessage,
    countryInfoMessage,
    newsletterCheckboxLabel,
    newsletterCheckboxBody,
    termsAndConditionsCheckboxLabel,
    termsAndConditionsCheckboxBody,
    ctaName,
    colorScheme,
    iconName,
    disclaimerText,
    backgroundColor,
    backgroundImage,
    consent,
    showCaptcha,
    submittedBody,
    submittedHeadingType,
    submittedheadingBody,
    defaultError,
    image
  } = fields;

  const pdfLeadsFormProps = {
    headerType,
    headerBody,
    firstNameLabel,
    firstNameInfoText,
    firstNameMissingMessage,
    lastNameLabel,
    lastNameInfoText,
    lastNameMissingMessage,
    emailLabel,
    emailInfoText,
    emailWarningMessage,
    emailMissingMessage,
    phoneAreaLabel,
    phoneAreaInfoText,
    phoneLabel,
    phoneInfoText,
    phoneWarningMessage,
    phoneMissingMessage,
    countryLabel,
    countryWarningMessage,
    countryInfoMessage,
    termsAndConditionsCheckboxLabel,
    termsAndConditionsCheckboxBody,
    newsletterCheckboxLabel,
    newsletterCheckboxBody,
    ctaName,
    colorScheme,
    iconName,
    disclaimerText,
    consent,
    showCaptcha,
    captchaSiteKey: config.webSettings.verificationCodeKey
  };

  const [isSubmited, setIsSubmited] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [hasError, setHasError] = useState(false);

  const currentComponent = useRef();

  const submitted = {
    submittedheadingBody,
    submittedHeadingType,
    submittedBody,
    image
  };
  const pdpTradeInClasses = classNames(getOverallSettingsClasses(fields));

  // background image will override background color */
  let backgroundStyle = {};
  if (backgroundColor && backgroundColor.fields?.key?.value) {
    backgroundStyle = {
      background: backgroundColor.fields.key.value
    };
  }
  if (backgroundImage && backgroundImage.value?.src) {
    backgroundStyle = {
      background:
        `linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.2277) 12%,
        rgba(0, 0, 0, 0.99) 52%
      ), url(` +
        backgroundImage.value.src +
        `)`
    };
  }

  const simpleHeroProps = {
    titleType: titleType,
    titleBody: titleBody,
    body: description
  };

  const onSubmit = async data => {
    setHasError(false);
    let language = lang.indexOf("-") > -1 ? lang.split("-")[0] : "en";
    api.tradein
      .save(null, {
        emailAddress: data.email,
        country: data.country.code,
        language: language,
        firstName: data.firstname,
        lastName: data.lastname,
        phone: data.phoneArea + " " + data.phoneNumber
      })
      .then(res => {
        switch (res.status) {
          case 200:
            scrollToSmooth(currentComponent.current);
            setIsSubmited(true);
            window.location.hash = `${page.itemId};submitted`;
            break;
          default:
            setHasError(true);
            setErrorMessage(defaultError?.value || res.msg);
            break;
        }
      })
      .catch(res => {
        setHasError(true);
        setErrorMessage(defaultError?.value || res.message);
      });
  };

  return (
    <div ref={currentComponent}>
      {!isSubmited && (
        <React.Fragment>
          {backgroundStyle && (
            <div style={backgroundStyle}>
              <div className={pdpTradeInClasses}>
              {simpleHeroProps.titleBody && simpleHeroProps.body && <SimpleHero {...simpleHeroProps} />}
              <div className="pdf-leads grid">
                <div className="left">
                  <PdfLeadsForm
                    {...{
                      ...pdfLeadsFormProps,
                      onSubmitForm: data => onSubmit(data),
                      hasError,
                      errorMessage
                    }}
                  />
                </div>
              </div>
              </div>
            </div>
          )}
        </React.Fragment>
      )}

      {isSubmited && (
        <div className="is-submitted grid">
          <div className="left">
            <div className={pdpTradeInClasses}>
              <TradeInSubmitted {...submitted} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PdpTradeIn;
